import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'mono-common-loading-animation-network',
  templateUrl: './loading-animation-network.component.html',
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class LoadingAnimationNetworkComponent {

  public size = input<string>('');

}
